export default __webpack_public_path__ + "static/media/particles.4754e6ef.png";